export const yesNo = [
    {name: 'Select', id: ''},
    {name: 'Yes', id: 1},
    {name: 'No', id: 2}
]